export default "__VITE_ASSET__CxTPiwbF__"